/**
 * Hide Sold Out Buttons
 * Hides any disabled add to cart buttons that show "Sold out" text
 */

document.addEventListener('DOMContentLoaded', function() {
  // Function to hide sold out buttons
  function hideSoldOutButtons() {
    // Find all quantity-submit-row__submit divs
    const submitRows = document.querySelectorAll('.quantity-submit-row__submit');
    
    submitRows.forEach(row => {
      // Check if this div contains a disabled button with "Sold out" text
      const button = row.querySelector('button[disabled]');
      if (button) {
        const buttonText = button.textContent.trim().toLowerCase();
        if (buttonText.includes('sold out') || buttonText.includes('soldout') || buttonText.includes('no stock')) {
          // Hide the entire div containing the sold out button
          row.style.display = 'none';
        }
      }
    });
  }

  // Function to show all submit rows first, then hide sold out ones
  function reshownAndRecheck() {
    // First, show all quantity-submit-row__submit divs
    const allSubmitRows = document.querySelectorAll('.quantity-submit-row__submit');
    allSubmitRows.forEach(row => {
      row.style.display = '';
    });
    
    // Then hide the sold out ones
    setTimeout(hideSoldOutButtons, 100);
  }

  // Run on page load
  hideSoldOutButtons();

  // On variant changes: reshown all rows first, then recheck
  document.addEventListener('on:variant:change', reshownAndRecheck);
  document.addEventListener('variant:change', reshownAndRecheck);
  
  // Run periodically to catch any dynamically added buttons
  setInterval(hideSoldOutButtons, 1000);
});
